import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  card: {
    // minWidth: 260,
    height: '100%',
    borderRadius: 5,
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    display: 'flex',
    flexDirection: 'column',
  },
  reqNum: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  numText: {
    lineHeight: 1.2,
    fontSize: 14,
    fontFamily: 'Averta Bold',
    color: '#007fff',
    fontWeight: 600,
    '& input': {
      display: 'none',
    },
  },
  header: {
    height: 33,
    // backgroundColor: '#44a570',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 15px',
    fontSize: 13,
    color: '#fff',
  },
  content: {
    padding: '20px 25px',
    paddingBottom: '20px !important',
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  hr: {
    height: 1,
    backgroundColor: '#9f9f9f',
    borderRadius: 2,
    margin: '8px 0 5px 0',
  },
  row4: {
    display: 'flex',
    alignItems: 'center',
    '& span': {
      flex: '1',
      textAlign: 'left',
    },
  },
  bold: {
    fontFamily: 'Averta Bold',
    fontWeight: 'bold',
  },
  row: {
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 10,
    fontFamily: 'Averta Bold',
    lineHeight: 1.5,
    color: '#303030',
    fontWeight: 'bold',
    cursor: 'default',
    '& a': {
      textDecoration: 'none',
      color: '#ffffff',
    },
    '& a:disabled': {
      textDecoration: 'none',
      color: '#ffffff',
    },
  },
  row2: {
    padding: '0 15px',
    lineHeight: 1.8,
    height: 12,
  },
  light1: {
    fontFamily: 'Averta Light',
    fontWeight: '300',
    color: '#ffffff',
  },
  light: {
    fontFamily: 'Averta Light',
    fontWeight: '300',
    color: '#43424b',
  },
  file: {
    marginBottom: 25,
    color: 'rgb(68, 165, 112)',
    display: 'block',
    textAlign: 'center',
  },
  light2: {
    fontFamily: 'Averta Light',
    fontWeight: 300,
    color: '#303030',
    '& input': {
      display: 'none',
    },
    '& button': {
      marginLeft: 10,
      backgroundColor: '#007fff !important',
      color: '#fff',
      width: '65px',
      height: '27px',
      padding: '0',
      fontSize: '10px',
      fontFamily: 'Averta Light',
      fontWeight: '300',
      borderRadius: '5px',
    },
    '& button:disabled': {
      color: '#ffffff',
      background: '#cacaca !important',
    },
    '& label': {
      marginLeft: 10,
      backgroundColor: '#007fff',
      color: '#fff',
      width: '65px',
      height: '27px',
      padding: '0',
      fontSize: '10px',
      fontFamily: 'Averta Light',
      fontWeight: '300',
      borderRadius: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  bigText: {
    fontSize: 30,
    fontFamily: 'Averta Bold',
    fontWeight: 800,
    lineHeight: 1,
    marginBottom: 10,
  },
  butCont: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '5px',
    width: '100%',
    '& button': {
      flex: '1',
    },
    '& p': {
      flex: '1',
    },
  },
  popup: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: '#000000aa',
    zIndex: 999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  close: {
    position: 'absolute',
    top: 10,
    right: 15,
    height: 25,
    cursor: 'pointer',
    fill: 'gray',
    width: 15,
  },
  statusContainer: {
    '& p': {
      padding: '10px 5px',
      borderRadius: 5,
      fontSize: 12,
      marginBottom: 0,
      marginTop: 15,
    },
  },
  popUpCard: {
    position: 'relative',
    padding: '15px',
    boxSizing: 'border-box',
    width: 380,
    height: 'auto',
    boxShadow: '2px 2px 6px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    // position: 'absolute',
    // right: '9vw',
    zIndex: 10,
    // top: 110,
    '@media (max-width:500px)': {
      width: '100%',
    },
    '& p': {
      margin: '25px 0',
    },
  },
  actionContainer: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  yesBtn: {
    color: '#ffffff',
    padding: '10px 15px',
    background: '#007FFF',
    border: 'none',
    borderRadius: '5px',
    width: 80,
    '&:hover': {
      color: '#ffffff',
      background: '#007FFF',
    },
  },
  noBtn: {
    color: '#ffffff',
    padding: '10px 15px',
    background: '#FF0000',
    marginRight: 10,
    border: 'none',
    borderRadius: '5px',
    width: 80,
    '&:hover': {
      color: '#ffffff',
      background: '#FF0000',
    },
  },
  confirm_container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  confirm: {
    color: '#007fff',
    marginTop: 10,
    fontSize: 12,
  },
  margin: {
    marginBottom: 7,
  },
  but2: {
    backgroundColor: '#e4464b !important',
  },
  but3: {
    backgroundColor: '#3c845d !important',
    '&:hover': {
      backgroundColor: '#3c845d !important',
    },
  },
  disabled: {
    color: '#ffffff',
    background: '#cacaca !important',
  },
  but: {
    width: '100%',
    fontSize: 10,
    height: 30,
    color: '#fff',
    borderRadius: 5,
    textTransform: 'none',
    cursor: 'pointer',
    marginTop: 6,
    marginBottom: -4,
  },
  numText: {
    lineHeight: 1.2,
    fontSize: 14,
    fontFamily: 'Averta Bold',
    color: '#000000',
    fontWeight: 600,
    '& input': {
      display: 'none',
    },
    '& button': {
      marginLeft: 10,
      backgroundColor: '#007fff !important',
      color: '#fff',
      width: '65px',
      height: '27px',
      padding: '0',
      fontSize: '10px',
      fontFamily: 'Averta Light',
      fontWeight: '300',
      borderRadius: '5px',
    },
    '& button:disabled': {
      color: '#ffffff',
      background: '#cacaca !important',
    },
    '& label': {
      marginLeft: 10,
      backgroundColor: '#007fff',
      color: '#fff',
      width: '65px',
      height: '27px',
      padding: '0',
      fontSize: '10px',
      fontFamily: 'Averta Light',
      fontWeight: '300',
      borderRadius: '5px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  uploadBtn: {
    display: 'flex',
  },
  red: {
    backgroundColor: '#e4464b',
  },
  bigRow: {
    alignItems: 'flex-start',
  },
  avatar: {
    height: 30,
    width: 30,
  },
  icon: {
    height: 15,
    width: 15,
    fill: '#f8b100',
    margin: '0 5px 0 10px',
  },
  row3: {
    alignItems: 'start',
  },
  loader: {
    width: '20px !important',
    height: '20px !important',
    color: '#ffffff',
  },
  uploadLabel: {
    cursor: 'pointer',
    '&:hover': {
      opacity: '0.85',
    },
  },
}));
